import React, { useMemo } from 'react';
import { Typography } from '@ui/components';
import { useReport } from './UsageReportContext';
import { Table } from './Table';

export const LicenseActiveUsersTable: React.FC = () => {
  const { activeUsers } = useReport();
  const columns = useMemo(
    () => [
      { Header: 'Windows user', accessor: 'user' as const },
      { Header: 'CAD account', accessor: 'autodesk' as const },
      { Header: 'Machine name', accessor: 'machine' as const },
    ],
    [],
  );

  return (
    <Table label='current user activity' data={activeUsers} columns={columns}>
      <Typography variant='h5'>Currently active</Typography>
    </Table>
  );
};
